var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFilled = function SvgFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 7a2 2 0 0 0-2-2H3a2 2 0 0 0-2 2v.764c0 .757.449 1.44.987 1.973C2.49 10.237 3 10.991 3 12s-.509 1.763-1.013 2.263C1.449 14.796 1 15.479 1 16.236V17a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2v-.764c0-.758-.449-1.44-.987-1.973C21.51 13.763 21 13.009 21 12s.509-1.763 1.013-2.263c.538-.533.987-1.216.987-1.973V7Zm-12.293 7.707 4-4a1 1 0 0 0-1.414-1.414l-4 4a1 1 0 1 0 1.414 1.414ZM9 10a1 1 0 1 0 2 0 1 1 0 0 0-2 0Zm6 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z",
    fill: "#777E91"
  })));
};
export default SvgFilled;